import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'Src/js/components/blain-form/validation';
import ActionModal from '../modals/ActionModal.vue';
import BButton from '../BButton.vue';
import FieldNote from "Src/js/components/FieldNote.vue";
import Icon from '../Icon.vue';
import ReverseOrder from 'JS/components/ReverseOrder';
import { BButtonSubmitButton, BForm, BTextField } from 'Src/js/components/blain-form';
import { FormatOptions } from 'JS/components/blain-form/formatting';
import { IGiftCard } from 'JS/types/Checkout';
import { reactive } from 'vue';
import { useBreakpoints } from 'JS/composables/breakpoint';


const __default__ = {
	inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ApplyGiftCardModal',
  props: {
    loading: { type: Boolean },
    error: null
  },
  emits: ["submit", "close"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'submit', giftCard: IGiftCard): void;
	(e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {





const giftCard: IGiftCard = reactive({
	giftCardNum: '',
	giftCardPin: ''
});

const { isMobile } = useBreakpoints();

const giftCardFormat: FormatOptions = {
	type: 'numeric',
	length: 16,
};

const pinFormat: FormatOptions = {
	type: 'numeric',
	length: 8,
};

async function onSubmit() {
	emit('submit', giftCard);
}

return { __sfc: true,emit, giftCard, isMobile, giftCardFormat, pinFormat, onSubmit, validation, ActionModal, BButton, FieldNote, Icon, BButtonSubmitButton, BForm, BTextField }
}

})